"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.radioGroupNovoDark = exports.radioGroupNovo = exports.radioGroup = exports.radioNovoDark = exports.radioNovo = exports.radio = void 0;
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const size_const_1 = __importDefault(require("../choices/size.const"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const { novo, novoDark } = oxygen_theme_1.default;
const radio = {
    borderSize: size_const_1.default.borderSizeDefault,
    borderStyle: 'solid',
    iconDotSize: size_const_1.default.default,
    iconSelectedColor: color_const_1.default.dodgerBlue,
    iconHoverColor: color_const_1.default.dodgerBlue300,
    iconFocusColor: color_const_1.default.dodgerBlue300,
    iconSet: 'classic',
    iconSize: size_const_1.default.default2x,
    iconSpacing: size_const_1.default.default,
    iconUnselectedColor: color_const_1.default.cloudyBlue,
    labelColor: color_const_1.default.pickledBluewood800,
    labelDisabledColor: color_const_1.default.pickledBluewood800,
};
exports.radio = radio;
const radioNovo = {
    iconDisabledColor: novo.icon06,
    iconHoverColor: novo.focus01,
    iconFocusColor: novo.focus01,
    iconSelectedColor: novo.action04,
    iconSet: 'novo',
    iconSize: '24px',
    iconSpacing: novo.spacing04,
    iconUnselectedColor: novo.ui03,
    labelColor: novo.textColor01,
    labelDisabledColor: novo.disabled02,
};
exports.radioNovo = radioNovo;
const radioNovoDark = {
    ...radioNovo,
    iconDisabledColor: novoDark.icon06,
    iconSelectedColor: novoDark.action04,
    iconUnselectedColor: novoDark.ui03,
    labelColor: novoDark.textColor01,
    labelDisabledColor: novoDark.disabled02,
};
exports.radioNovoDark = radioNovoDark;
const radioGroup = {
    verticalGroupMargin: size_const_1.default.default,
    horizontalGroupMargin: size_const_1.default.default2x,
};
exports.radioGroup = radioGroup;
const radioGroupNovo = {
    verticalGroupMargin: novo.spacing03,
    horizontalGroupMargin: novo.spacing06,
};
exports.radioGroupNovo = radioGroupNovo;
const radioGroupNovoDark = {
    ...radioGroupNovo,
};
exports.radioGroupNovoDark = radioGroupNovoDark;
